var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMecanico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#EA5D0E",
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 349.667 349.667",
    xmlSpace: "preserve",
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.834,197.204c24.125,0,80.846-29.034,80.846-98.603c0-9.703-0.237-19.076-1.036-27.933 c-1.313-17.434-4.884-32.884-13.776-44.725C229.467,9.835,209.519,0,174.834,0c-34.686,0-54.634,9.836-66.036,25.944 C99.911,37.779,96.339,53.22,95.025,70.643c-0.801,8.865-1.038,18.246-1.038,27.959C93.987,168.17,150.709,197.204,174.834,197.204 z M106.015,83.515c0.93,2.035,4.887,9.871,11.014,10.606c7.04,0.845,18.728-24.935,57.804-24.998 c39.077,0.063,50.764,25.843,57.804,24.998c6.127-0.735,10.085-8.572,11.014-10.606c0.19,4.993,0.259,10.047,0.259,15.087 c0,34.005-15.016,55.075-27.612,66.762c-15.872,14.727-33.494,20.072-41.466,20.072c-7.972,0-25.594-5.345-41.466-20.072 c-12.596-11.687-27.612-32.757-27.612-66.762C105.756,93.562,105.825,88.508,106.015,83.515z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.926,298.327c-4.127-25.665-12.624-58.724-29.667-70.472c-11.638-8.024-52.243-29.718-69.582-38.982l-0.3-0.16 c-1.983-1.059-4.403-0.847-6.17,0.541c-9.083,7.131-19.033,11.937-29.573,14.284c-1.862,0.415-3.39,1.738-4.067,3.521 l-10.733,28.291l-10.733-28.291c-0.677-1.783-2.205-3.106-4.067-3.521c-10.54-2.347-20.49-7.153-29.573-14.284 c-1.768-1.388-4.188-1.601-6.17-0.541c-17.133,9.155-58.235,31.291-69.831,39.107c-19.619,13.217-28.198,61.052-29.718,70.507 c-0.151,0.938-0.063,1.897,0.253,2.792c0.702,1.982,18.708,48.548,149.839,48.548s149.137-46.566,149.839-48.548 C324.989,300.224,325.077,299.264,324.926,298.327z M257.694,332.002c-20.077,5.113-46.949,8.704-82.865,8.704 c-35.918,0-62.787-3.591-82.867-8.704c6.136-52.384,0.311-97.785-2.797-116.367c3.126-1.735,6.313-3.487,9.479-5.223 c11.773,31.122,13.855,70.533,13.855,70.533h56.999h10.662h56.997c0,0,2.085-39.447,13.874-70.575 c3.163,1.728,6.347,3.474,9.472,5.202C257.397,234.117,251.551,279.56,257.694,332.002z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMecanico);
export default __webpack_public_path__ + "static/media/mecanico.d3fcfecf774e2a19c9c68e32d4277e99.svg";
export { ForwardRef as ReactComponent };